// extracted by mini-css-extract-plugin
export default {"root":"WoyBtgI3vqKUfTnHaTaH","placeHolderShimmer":"CU9C_TxdTIsHuget8DPL"};